import React, { useState, useEffect } from "react";
import { Box, Chip, MenuItem, Select } from "@mui/material";

const DRSFilter = ({ getData, setDrsStatus, drsStatus, width, setPage }) => {
  //   const [options, setOption] = useState();
  const [selectedValue, setSelectedValue] = useState(drsStatus);

  useEffect(() => {
    if (selectedValue) {
      getData(1);
      setPage(1);
    }
  }, [selectedValue]);
  return (
    <Select
      style={{ width: width || "22%", height: "40px", marginRight: "10px" }}
      required
      displayEmpty
      renderValue={drsStatus !== "" ? undefined : () => "Select DRS Status"}
      value={selectedValue}
      onChange={(e) => {
        setDrsStatus(e.target.value);
        setSelectedValue(e.target.value);
      }}
    >
      <MenuItem value={""}>All</MenuItem>
      <MenuItem value={"success"}>Success</MenuItem>
      <MenuItem value={"failed"}>Failed</MenuItem>
    </Select>
  );
};

export default DRSFilter;
